// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"da4225a6","599":"45940183"}[chunkId] + ".chunk.js";
};